import React from 'react';
import { NewNavbarProvider } from 'Components/UI/Navigation/NewNavbar/NewNavbarContext';
import NewNavbarDrawer from 'Components/UI/Navigation/NewNavbar/NewNavbarDrawer';

const Navbar = (props) => {
  return (
    <NewNavbarProvider>
      <NewNavbarDrawer {...props} />
    </NewNavbarProvider>
  );
};

export default Navbar;
